import { Icon } from '@chakra-ui/icons';

function SuccessCircleIcon(props) {
  return (
    <Icon viewBox="0 0 16 17" {...props}>
      <path
        d="M8.00004 1.8335C4.32404 1.8335 1.33337 4.82416 1.33337 8.50016C1.33337 12.1762 4.32404 15.1668 8.00004 15.1668C11.676 15.1668 14.6667 12.1762 14.6667 8.50016C14.6667 4.82416 11.676 1.8335 8.00004 1.8335ZM6.66737 11.4422L4.19204 8.97216L5.13337 8.02816L6.66604 9.55816L10.1954 6.02883L11.138 6.9715L6.66737 11.4422Z"
        fill="#38A169"
      />
    </Icon>
  );
}

export default SuccessCircleIcon;
